import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const StaticPageIconStyles = makeStyles()((theme: Theme) => ({
  staticPageIcon: {
    marginBottom: '1.25rem',
    '& .colorChange': {
      fill: theme.palette.primary.main,
    },
    '& .backgroundFill': {
      fill: theme.palette.svgStyles?.fill,
      stroke: theme.palette.svgStyles?.stroke,
    },
    '& path.colorChangeStroke': {
      stroke: theme.palette.primary.main,
    },
    '& .customFillElement': {
      fill: theme.palette.svgStyles?.fillForElements,
    },
  },
}));
